import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import RegionTooltip from '../tooltips/RegionTooltip';
import sortRegions from '../../../../data/regionsSorter';
import 'react-select/dist/react-select.css';


class RegionSelectorOfAppellate extends Component {
  render() {
    const regions = sortRegions(map2Options(regionOptions))

    return (
      <div className="region-selector-container">
        <label className="region-selector-label" htmlFor="region-selector">Region: </label>
        <div className="region-selector">
          <Select
            name="form-field-name"
            options={regions}
            multi={true}
            simpleValue={true}
            value={this.props.filters.get('court_id')}
            placeholder="All Courts"
            onChange={(court_id) => this.props.onChange({ court_id: court_id || '' })}/>
        </div>
        <RegionTooltip/>
      </div>
    )
  }
}

RegionSelectorOfAppellate.defaultProps = {
  onChange: () => {
  }
};

RegionSelectorOfAppellate.propTypes = {
  onChange: PropTypes.func,
};

// todo - wth lol, refactor all this
export function map2Options(mapOfOptions) {
  return Object.keys(mapOfOptions).map(instance => ({
    value: instance,
    label: mapOfOptions[instance],
  }));
}

export const regionOptions = {
  '01': 'First Circuit',
  '02': 'Second Circuit',
  '03': 'Third Circuit',
  '04': 'Fourth Circuit',
  '05': 'Fifth Circuit',
  '06': 'Sixth Circuit',
  '07': 'Seventh Circuit',
  '08': 'Eighth Circuit',
  '09': 'Ninth Circuit',
  '10': 'Tenth Circuit',
  '11': 'Eleventh Circuit',
  'DC': 'District of Columbia',
  'CAFC': 'Federal Circuit',
};

export default RegionSelectorOfAppellate;



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/RegionSelectorOfAppellate/RegionSelectorOfAppellate.js
 **/